import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { SIGNIN_USER, SIGNOUT_USER, GET_USER } from 'constants/ActionTypes';
import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
  setReduxAuthenticated2FA,
  hideAuthLoader,
  hideMessage,
  captchaReset,
} from 'actions/Auth';

import { resetFiltersRedux } from 'actions/Filters';

import { getIdUser, getHashEmpresa, getToken, encrypt } from 'util/cobUtils';

import api from 'services/api';
import api2 from 'services/api2';

const signInUserWithEmailPasswordRequest = async (
  conta,
  username,
  password,
  ip,
  tokenCaptcha
) =>
  api2
    .post('/login', { conta, username, password, ip, tokenCaptcha })
    .then((authUser) => authUser)
    .catch((error) => error);

const getUsuarioLogadoRequest = async (idHashEmp, uuidUsuario) =>
  api
    .post('/usuario_logado', { idHashEmp, uuidUsuario })
    .then((authUser) => authUser)
    .catch((error) => error);
/*
const signOutRequest = async () =>
  await auth
    .signOut()
    .then((authUser) => authUser)
    .catch((error) => error);
*/

// AUTENTICACAO AQUI
function* signInUserWithEmailPassword({ payload }) {
  const { conta, username, password, ip, tokenCaptcha } = payload;
  try {
    if (conta && username && password) {
      const retornoAuth = yield call(
        signInUserWithEmailPasswordRequest,
        conta,
        username,
        password,
        ip,
        tokenCaptcha
      );

      if (retornoAuth && retornoAuth.message) {
        const status = retornoAuth?.response?.status;
        if (status == 401)
          yield put(showAuthMessage('Usuário e/ou Senha Incorretos.'));
        else
          yield put(
            showAuthMessage(
              retornoAuth?.response?.data || retornoAuth?.message || 'Erro ao autenticar.'
            )
          );

        yield put(captchaReset());
      } else if (retornoAuth?.request?.status == 201 || retornoAuth?.status == 201) {
        let acesso = retornoAuth.data;
        acesso = JSON.stringify(acesso, undefined, '');
        acesso = encrypt(acesso);

        yield put(resetFiltersRedux());
        yield put(setReduxAuthenticated2FA(retornoAuth.data));
      } else {
        const data = retornoAuth?.data;
        if (data && data.id_uuid) {
          let acesso = data;
          acesso = JSON.stringify(acesso, undefined, '');
          acesso = encrypt(acesso);
          localStorage.setItem('cobcloud_user', data.id_uuid);
          localStorage.setItem('cobcloud_token', data.token);
          localStorage.setItem('cobcloud_token2', data.codemp);
          localStorage.setItem('access', acesso);
          localStorage.setItem('ip', ip);
          yield put(resetFiltersRedux());
          yield put(userSignInSuccess(data));
        } else {
          yield put(
            showAuthMessage('Falha ao autenticar. Resposta inválida do servidor.')
          );
          yield put(captchaReset());
        }
      }

      yield put(hideAuthLoader());
    }
  } catch (error) {
    yield put(showAuthMessage(error?.message || 'Erro inesperado ao autenticar.'));
    yield put(captchaReset());
  }
}

// PREENCHER NO REDUX O USUARIO LOGADO
function* getUsuarioLogado() {
  const idHashEmp = getHashEmpresa();
  const idHashUser = getIdUser();

  try {
    if (idHashEmp != '' && idHashUser != '') {
      const retornoAuth = yield call(
        getUsuarioLogadoRequest,
        idHashEmp,
        idHashUser
      );

      if (retornoAuth?.data) {
        yield put(userSignInSuccess(retornoAuth.data));
      } else {
        yield put(
          showAuthMessage('Não foi possível obter o usuário logado.')
        );
      }
    }
  } catch (error) {
    yield put(showAuthMessage(error?.message || 'Erro ao obter usuário logado.'));
  }
}

function* logoutApi() {
  try {
    const usuario = localStorage.getItem('cobcloud_user');
    const ip = localStorage.getItem('ip') || '';

    yield call(() =>
      api.post(
        '/logout',
        { usuario, ip}
      )
    );
  } catch (error) {
  }
}

function* signOut() {
  try {
     yield call(logoutApi);

    if (window.Featurebase) {
      window.Featurebase('shutdown');
    }
    
    localStorage.removeItem('cobcloud_user');
    localStorage.removeItem('user_menu');
    localStorage.removeItem('cobcloud_token');
    localStorage.removeItem('cobcloud_token2');
    localStorage.removeItem('access');
    localStorage.removeItem('ip');
    yield put(userSignOutSuccess(signOutUser));
    yield put(hideMessage());
    yield put(hideAuthLoader());
  } catch (error) {
    yield put(showAuthMessage(error?.message || 'Erro ao sair da sessão.'));
  }
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export function* userLogado() {
  yield takeEvery(GET_USER, getUsuarioLogado);
}

export default function* rootSaga() {
  yield all([fork(signInUser), fork(signOutUser), fork(userLogado)]);
}
